import { render } from "./TableLoader.vue?vue&type=template&id=36804510&scoped=true&ts=true"
import script from "./TableLoader.vue?vue&type=script&lang=ts"
export * from "./TableLoader.vue?vue&type=script&lang=ts"

import "./TableLoader.vue?vue&type=style&index=0&id=36804510&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36804510"]])

export default __exports__